module.exports = __webpack_public_path__ + "static/media/PD.03a43c75.jpg";